import { Contract } from '@ethersproject/contracts';

export const contractAbi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'planIds',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'ActivatedArcadeCreditBuyPlans',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'planIds',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'ActivatedTamaStakePlans',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'planId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'arcadeCredits',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tamaRequired',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'isActivated',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'AddedNewArcadeCreditBuyPlan',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'planId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'stakeDurationInSeconds',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'isActivated',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'AddedNewTamaStakePlan',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'arcadeCreditBuyPlan',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'arcadeCreditsBought',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tamaPaid',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'ArcadeCreditsBought',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'totalArcadeCreditsBought',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'totalTamaRequired',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tamaPercentageToBurn',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tamaPercentageToSendToStakingRewardPool',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tamaAddedToP2eRewardPool',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tamaBurned',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'stakingRewardsPoolBalance',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'ArcadeCreditsBoughtFromStakingRewardsPool',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'planIds',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'DeactivatedArcadeCreditBuyPlans',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'planIds',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'DeactivatedTamaStakePlans',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'gameId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'result',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'GameResultPublished',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint8',
                name: 'version',
                type: 'uint8',
            },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'previousAdminRole',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'newAdminRole',
                type: 'bytes32',
            },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleGranted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleRevoked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address[]',
                name: 'addresses',
                type: 'address[]',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'amounts',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'p2eRewardPoolBalanceLeft',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'TamaPayoutFromP2eRewardPool',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'planId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'stakeId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'unlockTime',
                type: 'uint256',
            },
        ],
        name: 'TamaStaked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'TamaTokensDepositedToUserStakes',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'TamaTokensWithdrawnFromUserStakes',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'stakeIds',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'totalUnstakedTamaAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'TamaUnstakedBatch',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'planId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'arcadeCredits',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tamaRequired',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'UpdatedArcadeCreditBuyPlan',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'by',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'planId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'stakeDurationInSeconds',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
        ],
        name: 'UpdatedTamaStakePlan',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_arcadeCredits',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_tamaRequired',
                type: 'uint256',
            },
            { internalType: 'bool', name: '_activatePlan', type: 'bool' },
        ],
        name: 'addNewArcadeCreditBuyPlan',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_stakeDurationInSeconds',
                type: 'uint256',
            },
            { internalType: 'bool', name: '_activatePlan', type: 'bool' },
        ],
        name: 'addNewTamaStakePlan',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'arcadeCreditBuyPlans',
        outputs: [
            {
                internalType: 'uint256',
                name: 'arcadeCredits',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'tamaRequired',
                type: 'uint256',
            },
            { internalType: 'bool', name: 'isActive', type: 'bool' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'arcadeCreditBuyPlansAvailable',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256[]',
                name: '_planIds',
                type: 'uint256[]',
            },
        ],
        name: 'batchActivateArcadeCreditBuyPlans',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256[]',
                name: '_planIds',
                type: 'uint256[]',
            },
        ],
        name: 'batchActivateTamaStakePlans',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256[]',
                name: '_planIds',
                type: 'uint256[]',
            },
        ],
        name: 'batchDeactivateArcadeCreditBuyPlans',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256[]',
                name: '_planIds',
                type: 'uint256[]',
            },
        ],
        name: 'batchDeactivateTamaStakePlans',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256[]',
                name: '_stakeIds',
                type: 'uint256[]',
            },
        ],
        name: 'batchUnstakeTama',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_planId', type: 'uint256' }],
        name: 'buyArcadeCredits',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_totalArcadeCreditsToBuy',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_totalTamaRequired',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_tamaPercentageToBurn',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_tamaPercentageToSendToStakingRewardPool',
                type: 'uint256',
            },
        ],
        name: 'buyArcadeCreditsFromStakingRewardPool',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'currentStakedAmountAvailableInContract',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_tokenAmount',
                type: 'uint256',
            },
        ],
        name: 'depositTamaTokensBackToUserStakes',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'gameResults',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_address', type: 'address' },
        ],
        name: 'getAllActiveStakes',
        outputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'stakedAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'stakeTime',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'tamaStakePlanId',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct Tamadoge_P2E_V2.TamaStake[]',
                name: '',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_address', type: 'address' },
        ],
        name: 'getAllStakes',
        outputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'stakedAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'stakeTime',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'tamaStakePlanId',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct Tamadoge_P2E_V2.TamaStake[]',
                name: '',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleAdmin',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_address',
                type: 'address',
            },
            { internalType: 'uint256', name: '_stakeId', type: 'uint256' },
        ],
        name: 'getStake',
        outputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'stakedAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'stakeTime',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'tamaStakePlanId',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct Tamadoge_P2E_V2.TamaStake',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_address', type: 'address' },
        ],
        name: 'getTotalActiveStakes',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_address', type: 'address' },
        ],
        name: 'getTotalStakes',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_address', type: 'address' },
        ],
        name: 'getTotalTamaStaked',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'hasRole',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_tamaToken',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_adminWallet',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_tamaPerCreditToSendToRewardPool',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_tamaPercentageToSendToStakingRewardPool',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_tamaPercentageToBurn',
                type: 'uint256',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'arcadeCredits',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'tamaRequired',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'isActive',
                        type: 'bool',
                    },
                ],
                internalType: 'struct Tamadoge_P2E_V2.ArcadeCreditBuyPlan[]',
                name: '_arcadeCreditBuyPlans',
                type: 'tuple[]',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'stakeDurationInSeconds',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'isActive',
                        type: 'bool',
                    },
                ],
                internalType: 'struct Tamadoge_P2E_V2.TamaStakePlan[]',
                name: '_tamaStakePlans',
                type: 'tuple[]',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'p2eRewardPoolBalance',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: '_addresses',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: '_amounts',
                type: 'uint256[]',
            },
        ],
        name: 'payoutTama',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_gameId', type: 'uint256' },
            { internalType: 'string', name: '_result', type: 'string' },
        ],
        name: 'publishIpfsResult',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_planId', type: 'uint256' },
            {
                internalType: 'uint256',
                name: '_amountToStake',
                type: 'uint256',
            },
        ],
        name: 'stakeTama',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'stakingRewardsPoolBalance',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceId',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tamaPerCreditToSendToRewardPool',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tamaPercentageToBurn',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tamaPercentageToSendToStakingRewardPool',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'tamaStakePlans',
        outputs: [
            {
                internalType: 'uint256',
                name: 'stakeDurationInSeconds',
                type: 'uint256',
            },
            { internalType: 'bool', name: 'isActive', type: 'bool' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tamaStakePlansAvailable',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tamaToken',
        outputs: [
            {
                internalType: 'contract IERC20Burnable',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalStakedAmountInContract',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalTamaBurned',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_planId', type: 'uint256' },
            {
                internalType: 'uint256',
                name: '_arcadeCredits',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_tamaRequired',
                type: 'uint256',
            },
        ],
        name: 'updateArcadeCreditBuyPlan',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_planId', type: 'uint256' },
            {
                internalType: 'uint256',
                name: '_stakeDurationInSeconds',
                type: 'uint256',
            },
        ],
        name: 'updateTamaStakePlan',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_tokenAmount',
                type: 'uint256',
            },
        ],
        name: 'withdrawTamaTokensFromUserStakes',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];

export const getContract = (signer) => {
    var contract = new Contract(
        process.env.REACT_APP_CONTRACT_ADDRESS,
        contractAbi,
        signer
    );
    return contract;
};
